import React from "react";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Offcanvas } from "react-bootstrap";
import { Mail } from "@mui/icons-material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileCode } from "@fortawesome/free-regular-svg-icons";
import style from "./AddYourSignature.module.css";
import { useEffect } from "react";
import axios from "axios";
import { useState } from "react";
import SignatureHtml from "./htmlView/SignatureHtml";
import Gmailview from "./gmailView/GmailView";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Typography
      component="div"
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {<Box p={3}> {children}</Box>}
    </Typography>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function AddYourSignature() {
  const [value, setValue] = React.useState(0);
  // const [loading, setLoading] = useState(false);
  // const [mySignatureHtml, setMySignatureHtml] = useState("");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  // const MySignatureHtml = async () => {
  //   try {
  //     setLoading(true);
  //     const response = await axios.get("/my-signature");
  //     if (response.data.status === 200) {
  //       setMySignatureHtml(response.data.my_signature[0]);
  //     } else {
  //       console.log(response.data);
  //     }
  //     setLoading(false);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  // useEffect(() => {
  //   MySignatureHtml();
  // }, []);

  return (
    <>
      <Offcanvas.Header closeButton className="">
        <Offcanvas.Title className="ms-2">
          Add To Your Signature
        </Offcanvas.Title>
      </Offcanvas.Header>
      <div className=" text-white p-0 border border-silver sidebar_tabination container-fuild ">
        <div className="row">
          <div className="col-3">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="basic tabs example "
              className={`  ${style.tabs_wrapper} tabs_wrapper `}
            >
              <Tab
                className="tabs_item"
                label="Gmail"
                icon={<Mail />}
                {...a11yProps(0)}
                style={{
                  background: `${value === 0 ? "#F9EDC6" : "transparent"}`,
                  borderLeft: `${value === 0 ? " 2px solid #b99725" : ""}`,
                }}
              />
              <Tab
                className="tabs_item"
                label="HTML"
                icon={<FontAwesomeIcon icon={faFileCode} size="xl" />}
                {...a11yProps(1)}
                style={{
                  background: `${value === 1 ? "#F9EDC6" : "transparent"}`,
                  borderLeft: `${value === 1 ? " 2px solid #b99725" : ""}`,
                }}
              />
              {/* <Tab className='tabs_item' icon={<BrushIcon />}  {...a11yProps(2)} /> */}
            </Tabs>
          </div>
          <div className="col-9 text-dark">
            <TabPanel value={value} index={0} className={`${style.TabPanel}`}>
              {<Gmailview />}
            </TabPanel>
            <TabPanel value={value} index={1} className={`${style.TabPanel}`}>
              {<SignatureHtml />}
            </TabPanel>
            <TabPanel value={value} index={2} className={`${style.TabPanel}`}>
              3
            </TabPanel>
          </div>
        </div>
      </div>
    </>
  );
}
